// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AosController from "./aos_controller"
application.register("aos", AosController)

import DoctorSelectController from "./doctor_select_controller"
application.register("doctor-select", DoctorSelectController)

import PhoneInputController from "./phone_input_controller"
application.register("phone-input", PhoneInputController)

import SlidersController from "./sliders_controller"
application.register("sliders", SlidersController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import AbhaRegistrationController from "./abha_registration_controller"
application.register("abha-registration", AbhaRegistrationController)
